import { Production } from '@features/productions';
import { Grid } from '@radix-ui/themes';
import { ProductionCard } from '../components/ProductionCard';

interface ProductionSelectionProps {
    productions: Production[];
    onSelectProduction: (production: Production) => void;
}

export const ProductionSelectionUI = ({
    productions,
    onSelectProduction,
}: ProductionSelectionProps) => {
    // const columns = Math.min(productions.length, 3).toString();
    return (
        <Grid gap={'2'} columns={'3'} rows={'3'}>
            {productions.map((production) => {
                return (
                    <ProductionCard
                        key={production.id}
                        production={production}
                        onSelected={onSelectProduction}
                    />
                );
            })}
        </Grid>
    );
};
